// extracted by mini-css-extract-plugin
export default {"multi_button_container":"ButtonMultiLogin_multi_button_container__4yF1B","multi_button_text":"ButtonMultiLogin_multi_button_text__oLjoK","icon":"ButtonMultiLogin_icon__oeH6p"};